export default __webpack_public_path__ + "static/media/notFound.f334c911.jpg";